import { render, staticRenderFns } from "./totalMoney.vue?vue&type=template&id=b51f0cdc&scoped=true&"
import script from "./totalMoney.vue?vue&type=script&lang=js&"
export * from "./totalMoney.vue?vue&type=script&lang=js&"
import style0 from "./totalMoney.vue?vue&type=style&index=0&id=b51f0cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51f0cdc",
  null
  
)

export default component.exports